import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { useGetCompanies, useGetCompanyLocations } from "../../../../backend/masters";
import { DEFAULT_OPTIONS_PAYLOAD } from "../../../common/Table";

function AdminLocations({ onChange }: any) {
    const [t] = useState(new Date().getTime());
    const [company, setCompany] = useState<any>(null);
    const [associate_company, setAssociateCompany] = useState<any>(null);
    const [location, setLocation] = useState<any>(null);
    const { companies: parentCompanies, isFetching: fetchingParentCompanies }: any = useGetCompanies({ ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true, is_active_eq: true }, t });
    const { companies: associateCompanies, isFetching: fetchingAssociateCompanies }: any = useGetCompanies({
        ...DEFAULT_OPTIONS_PAYLOAD,
        filters: {
            is_parent_eq: 'false',
            is_active_eq: true,
            parent_company_id_eq: (company || {}).value
        }
    }, Boolean(company));
    const { locations, isFetching: fetchingLocations } = useGetCompanyLocations({
        ...DEFAULT_OPTIONS_PAYLOAD,
        includes: ['location'],
        include: ['location'],
        filters: {
            company_id_eq: (associate_company || {}).value
        },
        sort: [
            'location.name asc'
        ]
    }, Boolean((associate_company || {}).value));

    useEffect(() => {
        if (company) {
            setAssociateCompany(undefined);
            setLocation(undefined);
        }
    }, [company]);

    useEffect(() => {
        if (associate_company) {
            setLocation(undefined);
        }
    }, [associate_company]);

    useEffect(() => {
        if (company && associate_company && location) {
            onChange({
                company: company.value,
                associate_company: associate_company.value,
                location: location.value
            });
        }
    }, [location]);

    useEffect(() => {
        if (!fetchingParentCompanies && parentCompanies) {
            const _parentCompany = parentCompanies[0];
            if (_parentCompany) {
                setCompany({ value: _parentCompany.id, label: _parentCompany.name });
            }
        }
    }, [fetchingParentCompanies]);

    useEffect(() => {
        if (!fetchingAssociateCompanies && associateCompanies) {
            const _associate_company = associateCompanies[0];
            if (_associate_company) {
                setAssociateCompany({ value: _associate_company.id, label: _associate_company.name });
            }
        }
    }, [fetchingAssociateCompanies]);

    useEffect(() => {
        if (!fetchingLocations && locations) {
            const _location = locations[0];
            if (_location) {
                setLocation({ value: _location.location_id, label: _location.location.name });
            }
        }
    }, [fetchingLocations]);

    return (
        <>
            <div className="px-2">
                <label className="filter-label"><small>Company</small></label>
                <Select placeholder='Company' options={(parentCompanies || []).map((x: any) => {
                    return { value: x.id, label: x.name }
                })} onChange={setCompany} value={company} className="select-control" />
            </div>
            <div className="px-2">
                <label className="filter-label"><small>Associate Company</small></label>
                <Select placeholder='Associate Company' options={(associateCompanies || []).map((x: any) => {
                    return { value: x.id, label: x.name }
                })} onChange={setAssociateCompany} value={associate_company} className="select-control" />
            </div>
            <div className="px-2">
                <label className="filter-label"><small>Location</small></label>
                <Select placeholder='Location' options={(locations || []).map((x: any) => {
                    return { value: x.location_id, label: x.location.name }
                })} onChange={setLocation} value={location} className="select-control" />
            </div>
        </>
    )
}

export default AdminLocations;